import React from 'react';
import cx from './BlockTitle.scss';

export default class BlockTitle extends React.Component {

	static propTypes = {
		children: React.PropTypes.any,
	};

	render() {
		const { children, ...rest } = this.props;

		if(typeof children === 'string') {
			return (
				<h3
					className={cx('title')}
					dangerouslySetInnerHTML={{
						__html: children,
					}}
					{...rest}
					/>
			);
		} else {
			return (
				<h3 className={cx('title')} {...rest}>
					{children}
				</h3>
			);
		}
	}

}



// WEBPACK FOOTER //
// ./src/react/elements/GoalsPage/BlockTitle.js